import projectsStore from '../../stores/ProjectsStore'

// Igual que isSuperAdmin: función (no valor) para que se evalúe en el
// momento de cada navegación, leyendo el getter reactivo del store.
// Uso: isModuleEnabled('rdi')
export default function isModuleEnabled(code) {
	return projectsStore.getters.isModuleEnabled(code)
}